import React from "react";
import ReactTable from "react-table";
import { Container } from "reactstrap";

interface Props {
  referredDetailList: object[];
  partnerMembershipId: String;
}

class ReferredDetailTable extends React.Component<Props> {
  columns = [
    {
      Header: "Club",
      className: "text-center",
      accessor: "referidaClubNombre"
    },
    {
      Header: "# Membresía",
      accessor: "referidaNumeroMembresia"
    },
    {
      Header: " Titular",
      accessor: "referidaNombreTitular"
    },
    {
      Header: "Código aplicado",
      className: "text-center",
      accessor: "referidaCodigo"
    },
    {
      Header: "Fecha inicio",
      className: "text-center",
      accessor: "fechaInicio"
    },
    {
      Header: "Fecha fin",
      className: "text-center",
      accessor: "fechaFin"
    },
    {
      Header: "Estatus",
      className: "text-center",
      accessor: "estatus"
    },
    {
      Header: "Motivo cancelación",
      accessor: "motivoCancelacion"
    },
    {
      Header: "Fecha cancelación",
      className: "text-center",
      accessor: "fechaCancelacion"
    },
    {
      Header: "Tipo descuento",
      className: "text-center",
      accessor: "tipoDescuentoMembresiaReferida"
    }
  ];

  render() {
    const referidos = (this.props.referredDetailList || []).filter(
      x => x.tipo == "REFERIDO"
    );
    const referentes = (this.props.referredDetailList || []).filter(
      x => x.tipo == "REFERENTE"
    );

    return (
      <Container className="p-0">
        <p className="primaryTitle w-100">Membresías Socio Referidas</p>
        <ReactTable
          data={referidos}
          columns={this.columns}
          pageSize={(referidos.length || 0) + 2}
          showPagination={false}
          className="mt-3"
          getTrProps={(_, item) => {
            if (
              !!item &&
              !!item.original &&
              item.original.estatus == "CANCELADO"
            ) {
              return { style: { background: "#ddd" } };
            }
            return {};
          }}
        />

        <p className="primaryTitle w-100 mt-5">
          Membresía Socio Referente (que me refiere)
        </p>
        <ReactTable
          data={referentes}
          columns={this.columns}
          pageSize={(referentes.length || 0) + 2}
          showPagination={false}
          className="mt-3"
          getTrProps={(_, item) => {
            if (
              !!item &&
              !!item.original &&
              item.original.estatus == "CANCELADO"
            ) {
              return { style: { background: "#ddd" } };
            }
            return {};
          }}
        />
      </Container>
    );
  }
}

export default ReferredDetailTable;
